import { render, staticRenderFns } from "./CMSBlogCategoryList.vue?vue&type=template&id=52ab82c7&"
import script from "./CMSBlogCategoryList.vue?vue&type=script&lang=js&"
export * from "./CMSBlogCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports